module.exports = __webpack_public_path__ + "static/media/prev-control-carousel-inactive.6e063034.svg";